module.exports = __webpack_public_path__ + "img/greece.36e7bd24.jpg";